import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeDecimal'
})
export class RemoveDecimalPipe implements PipeTransform {
  transform(value: string): string {
    if (typeof value !== 'string') {
      return value; // Return original value if it's not a string
    }

    // Use a regular expression to match currency format
    const match = value.match(/^(\D*)(\d{1,3}(,\d{3})*)(\.\d{2})?$/);    
    if (!match) {
      return value; // Return the original value if it doesn't match the expected format
    }

    const currencySymbol = match[1]; // The currency symbol part (e.g., $, €, £)
    const integerPart = match[2]; // The whole number part
    const decimalPart = match[match.length -1]; // The decimal part (if any)

    // If decimal part is ".00", return just the integer part
    return decimalPart === '.00' ? `${currencySymbol}${integerPart}` : value;
  }
}
